import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import Immutable from 'immutable';
import Modal from '../../../../common/modal/Modal';
import AddCargoToItineraryByQrModalForms from './CargoOperationByQrModalForms';
import ConfirmationModal from '../../../../common/modal/ConfirmationModal';

const CargoOperationByQrButton = ({
  onClickAddItemToItinerary,
  cargoOperation,
  disabled,
  items,
  showQrModal,
  setShowQrModal,
  itineraryId,
  locationId,
}) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const openModal = () => setShowQrModal(true);

  const handleCloseConfirmation = () => {
    setShowConfirmationModal(true);
  };

  const handleClickConfirmConfirmation = () => {
    setShowConfirmationModal(false);
    setShowQrModal(false);
  };

  const handleClickCancelConfirmation = () => {
    setShowConfirmationModal(false);
  };

  const body = (
    // eslint-disable-next-line
    <div onKeyDown={(e) => e.stopPropagation()}>
      <AddCargoToItineraryByQrModalForms
        onClickAddItemToItinerary={onClickAddItemToItinerary}
        setShowModal={setShowQrModal}
        cargoOperation={cargoOperation}
        onClickClose={handleCloseConfirmation}
        totalItems={items}
        itineraryId={itineraryId}
        locationId={locationId}
      />
    </div>
  );

  return (
    <>
      <ConfirmationModal
        show={showConfirmationModal}
        onClickClose={handleCloseConfirmation}
        onClickConfirm={handleClickConfirmConfirmation}
        onClickCancel={handleClickCancelConfirmation}
        title="¿Estás seguro que deseas cancelar la operación?"
        body="Si cancelas la operación perderás los datos ingresados."
      />
      <Modal
        show={showQrModal}
        title={cargoOperation.label}
        size="lg"
        body={body}
      />
      <Button color="success" onClick={openModal} disabled={disabled}>
        <i className="fa fa-qrcode" /> {cargoOperation.label} por QR
      </Button>
    </>
  );
};

CargoOperationByQrButton.propTypes = {
  onClickAddItemToItinerary: PropTypes.func.isRequired,
  cargoOperation: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
  disabled: PropTypes.bool.isRequired,
  items: PropTypes.instanceOf(Immutable.List),
  showQrModal: PropTypes.bool.isRequired,
  setShowQrModal: PropTypes.func.isRequired,
  itineraryId: PropTypes.number.isRequired,
  locationId: PropTypes.number.isRequired,
};

CargoOperationByQrButton.defaultProps = {
  items: Immutable.List(),
};

export default CargoOperationByQrButton;
